import React, { ReactNode, useEffect, useRef } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { GoBackButton } from 'ui-components';
import {
  CALC_TEST_ID,
  RETIREMENT_CALCULATOR_NAMESPACE,
} from '../../tools/RetirementCalculator.const';
import { useRetirementCalculatorLayout } from './RetirementCalculatorLayout.context';

import useStyles from './RetirementCalculatorLayout.style';

export const RetirementCalculatorLayout: React.FC<{ children?: ReactNode }> = ({ children }) => {
  const {
    titleId,
    onBack,
    autoFocus,
    component: Component = 'main',
    className,
    testId = CALC_TEST_ID,
  } = useRetirementCalculatorLayout();
  const c = useStyles({});
  const [t] = useTranslation(RETIREMENT_CALCULATOR_NAMESPACE, { useSuspense: false });
  const stepRef = useRef<HTMLDivElement>(null);
  const autoFocusOnMount = useRef(autoFocus);

  useEffect(() => {
    if (autoFocusOnMount.current) {
      stepRef.current?.focus();
    }
  }, []);

  return (
    <Component className={clsx(c.root, className)} aria-labelledby={titleId} data-testid={testId}>
      <div className={c.content}>
        {onBack && (
          <GoBackButton
            label={t('back')}
            className={c.backLink}
            onClick={onBack}
            testId={`${CALC_TEST_ID}-back`}
          />
        )}

        <div className={c.layout} ref={stepRef} tabIndex={-1}>
          {children}
        </div>
      </div>
    </Component>
  );
};
